import React, { useState, useEffect } from "react";
// Customizable Area Start
import {
    StyleSheet,
    Text,
    TouchableOpacity,
    FlatList,
    View,
    TextInput,
    ActivityIndicator,
    ScrollView,
} from "react-native";
import DesktopHeader from "./DesktopHeader";
import DesktopMenue from "./DesktopMenue";
import scale from "../../../framework/src/Scale";
import { getAxiosAPI } from "../../../framework/src/Blocks/AxiosAPIBlock";
import { SortData } from "../../../framework/src/Utilities";
import { RygCircle, PopoverStatus, getColorCode } from "../../../components/src/RygCircle"
import * as IMG_CONST from '../../../blocks/dashboard/src/assets'

export default function CatalougeMaterialAi({ navigation }: { navigation: any }) {
    const order = JSON.parse(localStorage.getItem('order') || '{}');
    const [data, setData] = useState([]);
    const [query, setQuery] = useState(order?.material_name || "");

    const [offset, setOffset] = useState(0);
    const [loader, setLoader] = useState(false);

    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const [showDropdown, setShowDropdown] = useState(false);

    const [allMaterials, setAllMaterials] = useState<any[]>([]);
    const [filteredMaterials, setFilteredMaterials] = useState<any[]>([]);
    const [categories, setCategories] = useState<string[]>([]);
    const [selectedCategory, setSelectedCategory] = useState("All");

    const handleClick = (e: any) => {
        e.stopPropagation();
        setAnchorEl(e.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            getCatalogueData(query);
        }, 500); 

        return () => clearTimeout(delayDebounce);
    }, [query]);
    const getCatalogueData = async (searchText = "") => {
        setLoader(true);

        let url = `/bx_block_catalogue/catalogues/ai_catalog_search?manufacturer_name=${encodeURIComponent(order.manfacturer_name)}&limit=10&offset=0`;

        if (order?.material_name) {
            url += `&search_keyword=${encodeURIComponent(order.material_name)}`;
        }
        if(searchText){
            url += `&search_keyword=${encodeURIComponent(searchText)}`;
        }
        const res: any = await getAxiosAPI(url);

        if (!res.error) {
            const apiData = res.data.data;

            let materials: any[] = [];
            let categoryList: string[] = [];

            apiData.forEach((category: any) => {
                const categoryName = category.attributes.name;
                categoryList.push(categoryName);

                const mats = category.attributes.materials.data.map((mat: any) => ({
                    ...mat,
                    category_name: categoryName 
                }));

                materials = [...materials, ...mats];
            });

            const uniqueCategories = ["All", ...categoryList];

            setCategories(uniqueCategories);
            setAllMaterials(materials);
            setFilteredMaterials(materials);
        }

        setLoader(false);
    };

    useEffect(() => {
        getCatalogueData();
    }, []);

    useEffect(() => {
        if (selectedCategory === "All") {
            setFilteredMaterials(allMaterials);
        } else {
            const filtered = allMaterials.filter(
                (item) => item.category_name === selectedCategory
            );
            setFilteredMaterials(filtered);
        }
    }, [selectedCategory, allMaterials]);

    useEffect(() => {
    }, [offset]);

    
    const handleSearch = (text: any) => {
        setQuery(text)
    };

    const navigateTo = (item: any) => {
        localStorage.setItem('editMaterialData', JSON.stringify(item));
        localStorage.setItem('isAiFlow', 'true');
        navigation.navigate('NewMaterial')
    }

    const goToAddNewMaterial = () => {
        navigation.navigate('NewMaterial')
    }

    const ListEmptyView = () => {
        return (
            <View>
                <Text style={styles.heading2}>No Record Found</Text>
            </View>
        )
    }

    return (
        <View style={styles.desktopContainer}>
            {PopoverStatus(anchorEl, handleClose)}
            <DesktopHeader heading={'Materials List'} navigation={navigation} />
            <View style={styles.bottomDesktopCard}>
                <DesktopMenue navigation={navigation} />
                <View style={{ flex: 0.85 }}>
                
                    <View style={styles.outerCard}>
                        <View style={{ flexDirection: 'row',alignItems: 'center',marginBottom: 10, marginLeft:'20px',marginTop:'20px'}}>
                     <TouchableOpacity
                        onPress={() => navigation.goBack()}
                        style={{ marginRight: 10 }}
                    >
                        <Text style={{ fontSize: 20, color: '#4e3e71' }}>←</Text>
                    </TouchableOpacity>
                    <Text style={{ fontSize: 20, fontWeight: 'bold', color: '#4e3e71' }}>
                        {order?.manfacturer_name || "Manufacturer"}
                    </Text>
                </View>
                        <div style={{display:'flex'}}>
                        <View style={{ flexDirection: 'row', marginVertical: 12 }}>
                            <View style={styles.searchBox}>
                                <TextInput
                                    style={styles.input}
                                    placeholder="Search "
                                    autoCapitalize="none"
                                    autoCorrect={false}
                                    clearButtonMode="always"
                                    placeholderTextColor="#939ca3"
                                    value={query}
                                    onChangeText={queryText => handleSearch(queryText)}
                                />
                                <TouchableOpacity testID="navigateDashboard" onPress={() => setQuery('')}>
                                    <img src={query === '' ? IMG_CONST.search : IMG_CONST.cross} style={{ height: 30, width: 30, paddingRight: 15, paddingTop: 10 }} />
                                </TouchableOpacity>
                            </View>
                            {/* <TouchableOpacity style={styles.buttonView} onPress={goToAddNewMaterial}>
                                <Text style={styles.buttonText}>Add New Material</Text>
                            </TouchableOpacity> */}
                        </View>
                            <View style={{ marginBottom: 15, width: 300, marginLeft:'20px',position:'relative',zIndex:1 }}>
  
                            <Text style={{ fontSize: 16, color: '#4e3e71', marginBottom: 5 }}>
                                Select Category
                            </Text>

                            <TouchableOpacity
                                style={{
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                borderWidth: 1,
                                borderColor: '#ccc',
                                borderRadius: 8,
                                padding: 12,
                                backgroundColor: '#fff'
                                }}
                                onPress={() => setShowDropdown(!showDropdown)}
                            >
                                <Text>
                                    {selectedCategory}
                                </Text>

                                <Text>▼</Text>
                            </TouchableOpacity>

                            {showDropdown && (
                                <View
                                style={{
                                    borderWidth: 1,
                                    borderColor: '#ccc',
                                    borderRadius: 8,
                                    marginTop: 5,
                                    maxHeight: 200,
                                    backgroundColor: '#fff',
                                    zIndex: 999,
                                    position:'absolute',
                                    top:'69px',
                                    width:'100%'
                                }}
                                >
                                <ScrollView>
                                   {categories.map((item: string) => (
                                        <TouchableOpacity
                                            key={item}
                                            style={{
                                                padding: 12,
                                                backgroundColor:
                                                    selectedCategory === item ? '#4e3e71' : '#fff'
                                            }}
                                            onPress={() => {
                                                setSelectedCategory(item);
                                                setShowDropdown(false);
                                            }}
                                        >
                                            <Text
                                                style={{
                                                    color:
                                                        selectedCategory === item ? '#fff' : '#000'
                                                }}
                                            >
                                                {item}
                                            </Text>
                                        </TouchableOpacity>
                                    ))}
                                </ScrollView>
                                </View>
                            )}
                            </View>
                            </div>
                        {loader ? <ActivityIndicator
                            style={{ margin: 'auto', height: 100, width: 100, }}
                            size="large" color="#4e3e71" />
                            :
                            <View style={styles.card}>
                                <ScrollView style={{ flex: 1 }}>
                                    {/* {
                                        (query.length > 0 && data.length > 0) ?
                                            <View style={styles.add}>
                                                <Text style={styles.resultText}>{`Showing result "${query}"`}</Text>
                                            </View>
                                            :
                                            (query.length > 0 && data.length === 0) ?
                                                <View style={styles.add}>
                                                    <Text style={styles.resultText}>Searched Material not in the catlouge
                                                    </Text>
                                                </View> : null
                                    } */}

                                    <FlatList
                                        data={filteredMaterials}
                                        horizontal={false}
                                        ListEmptyComponent={ListEmptyView()}
                                        numColumns={6}
                                        keyExtractor={(item: any) => item.id}
                                        data-testId="flatList"
                                        renderItem={({ item }) => (
                                            <View>
                                                <TouchableOpacity data-testId="flatListItem" onPress={(e) => navigateTo(item)}>
                                                    <View style={styles.listm}>
                                                        <TouchableOpacity
                                                            style={styles.rygBtn}
                                                            activeOpacity={0.7}
                                                            data-testId="rygBtn"
                                                            onPress={handleClick}
                                                        >
                                                            <RygCircle backgroundColor={getColorCode(item.attributes.color_value)} />
                                                        </TouchableOpacity>
                                                        {
                                                            item.attributes.image ? <img src={item.attributes.image} style={{ height: 120, width: 120, borderRadius: 12 }} /> :
                                                                <img src={IMG_CONST.dummyMaterial} style={{ height: 120, width: 120, borderRadius: 12 }} />}
                                                        <View>
                                                            <Text style={styles.name} numberOfLines={2}>{item.attributes.name}</Text>
                                                            <View style={styles.priceView}>
                                                                <Text style={styles.discount_price}>
                                                                    {item.attributes.discount_price
                                                                        ? `$${item.attributes.discount_price}`.replace("$$", "$")
                                                                        : "$0.00"}
                                                                </Text>

                                                                <Text style={styles.price}>
                                                                    {item.attributes.price
                                                                        ? `$${item.attributes.price}`.replace("$$", "$")
                                                                        : "$0.00"}
                                                                </Text>
                                                            </View>
                                                        </View>
                                                    </View>
                                                </TouchableOpacity>

                                                {/* : null
                                                                        } */}
                                            </View>

                                        )}
                                    />
                                    <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'space-around', marginHorizontal: 200 }}>
                                        {offset < 1 ? null : <TouchableOpacity onPress={() => setOffset(offset - 10)}><Text style={{ color: '#4e3e71', fontWeight: 'bold' }}>{"< Prev"}</Text></TouchableOpacity>}
                                        {data.length < 12 ? null : <TouchableOpacity onPress={() => setOffset(offset + 10)}><Text style={{ color: '#4e3e71', fontWeight: 'bold' }}>{"Next >"}</Text></TouchableOpacity>}
                                    </View>
                                </ScrollView>

                            </View>
                        }
                    </View>
                </View>
            </View>

        </View>
    )
}

const styles = StyleSheet.create({
    desktopContainer: {
        flex: 1,
        flexDirection: 'column'
    },
    size: { color: '#b2bac6', fontSize: 10, paddingBottom: 5 },
    priceView: { flex: 1, flexDirection: 'row', justifyContent: 'space-between' },
    heading2: {
        marginVertical: 100,
        marginHorizontal: 'auto',
        color: '#b2bac6',
        fontSize: 24,
        fontWeight: 'bold',
        flexDirection: 'row',
        justifyContent: 'center'
    },
    name: {
        color: '#4e3e71',
        paddingVertical: 5,
        fontSize: 12,
        width: scale(40)
    },
    price: {
        color: '#b2bac6',
        paddingVertical: 5,
        fontSize: 13,
        textDecorationLine: 'line-through',
        width: scale(40)
    },
    discount_price: {
        color: '#4e3e71',
        paddingVertical: 5,
        fontSize: 14,
        width: scale(40)
    },
    listm: {
        overflow: 'hidden',
        shadowColor: '#b2bac6',
        height: 220,
        width: 160,
        shadowRadius: 5,
        shadowOpacity: 1,
        borderRadius: 12,
        padding: 16,
        borderColor: '#f2f4f5',
        borderWidth: 1,
        marginHorizontal: 8,
        marginVertical: 8,
        position: "relative"
    },
    rygBtn: {
        height: 20,
        width: 20,
        borderColor: "#ccc",
        borderWidth: 1,
        position: "absolute",
        top: -1,
        left: -1,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    button: {
        borderRadius: 12,
        paddingVertical: 15,
        paddingHorizontal: 20,
        marginVertical: 10,
        backgroundColor: '#4e3e71',
        // width: '20%',
        marginHorizontal: 10
    },
    loader: {
        position: 'absolute', left: 0, right: 0, bottom: 0, top: 0
    },
    buttonText: {
        color: '#e8fafe',
        fontSize: 17,
        textAlign: 'center',
    },
    buttonView: {
        borderRadius: 12,
        paddingHorizontal: 20,
        marginHorizontal: 20,
        backgroundColor: '#4e3e71',
        justifyContent: "center"
    },
    listItem: {
        height: 88,
        width: 360,
        marginHorizontal: 16,
        borderColor: '#e5e5e5',
        borderWidth: 1,
        borderRadius: 12,
        marginVertical: 5,
        padding: 20,
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    listItem_active: {
        height: 88,
        width: 360,
        marginHorizontal: 16,
        borderColor: '#4e3e71',
        borderWidth: 1,
        borderRadius: 12,
        marginVertical: 5,
        padding: 20,
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    role: {
        color: '#b2bac6',
        paddingHorizontal: 11,
        width: scale(50),

    },
    names: {
        color: '#4e3e71',
        fontSize: 15,
        paddingHorizontal: 11,
        width: scale(60),

    },

    add: {
        flexDirection: 'row',
        justifyContent: "flex-start"
    },
    resultText: {
        paddingVertical: 10,
        fontSize: 18

    },
    card: {
        flex: 1,
        marginTop: 10,
        borderRadius: 6,
        elevation: 3,
        backgroundColor: '#fff',
        marginVertical: 6,
    },
    filterIcon: {
        height: 48,
        width: 48,
        borderRadius: 24,
        padding: 8,
        borderWidth: 1,
        borderColor: '#4e3e71',
        marginVertical: 'auto',
        marginHorizontal: 'auto'
    },
    bottomDesktopCard: {
        flex: 1,
        flexDirection: 'row'
    },
    picker: {
        height: 50,
        width: 160,
        color: 'white',
        paddingHorizontal: 15,
        backgroundColor: '#4e3e71',
        borderRadius: 50,
    },
    searchBox: {
        flexDirection: 'row',
        borderWidth: 1,
        borderColor: '#8a8a8a',
        borderRadius: 50,
        height:'54px',
        marginTop:'6px'
    },
    input: {
        borderWidth: 0,
        flex: 1,
        paddingLeft: 10,
        height: 48,
        color: '#4e3e71',
        fontSize: 16,
        paddingStart: 20,
        width: 950
    },
    outerCard: {
        flex: 1,
        elevation: 3,
        backgroundColor: 'white',
        borderWidth: 1,
        borderRadius: 12,
        borderColor: '#7f7f7f',
        padding: 10,
        margin: 15,
        flexDirection: 'column'
    }
})